import { TaskFilterInput, PaginationSort } from '../gql/graphql';
import { toPagination } from './utils';

import { graphql } from '../gql';
import { useQuery } from '@apollo/client';

export const GET_TASKS = graphql(`
  query getTasks(
    $pagination: PaginationRequest
    $filters: TaskFilterInput
    $sort: PaginationSort
  ) {
    tasks(filters: $filters, pagination: $pagination, sort: $sort) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          targetUuid
          targetType
          targetName
          label
          system
          type
          status
          priority
          completedDate
          dueDate
          note
          user {
            cursor
            node {
              uuid
              username
              userId
              groups
              type
            }
          }
        }
      }
    }
  }
`);

export interface IUseTasksQueryArg {
  pageNumber: number;
  pageSize: number;
  sort?: PaginationSort;
  filters?: TaskFilterInput;
}

export function useTasksQuery({
  pageNumber,
  pageSize,
  sort,
  filters,
}: IUseTasksQueryArg) {
  const {
    loading,
    error,
    data,

    networkStatus,
    refetch,
  } = useQuery(GET_TASKS, {
    variables: {
      pagination: toPagination(pageNumber, pageSize),
      sort,
      filters: {
        ...filters,
      },
    },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
  });

  return {
    loading,
    error,
    data,
    networkStatus,
    refetch,
  };
}
